module.exports = __webpack_public_path__ + "static/media/what-nodejs-can-do.4d1fc5bd.md";